interface Colors {
  [key: string]: string
}

const colors: Colors = {
  A: 'e8cacf',
  B: 'e7cadb',
  C: 'e1cade',
  D: 'd9c9df',
  E: 'cfc8e0',
  F: 'c7c9e2',
  G: 'cbd9eb',
  H: 'cee6ec',
  J: 'd3e9e4',
  K: 'd2e7d8',
  L: 'd3e6cd',
  N: 'd3e6cd',
  P: 'e4edcd',
  Q: 'efeccf',
  W: 'ede0cb',
  X: 'ead1ca',
  Z: 'ead1ca',
}

export const getColorFromChar = (char: string) => {
  if (char in colors) {
    return '#' + colors[char]
    // return 'red'
  } else {
    return 'lightgray'
  }
}
